import classNames from "classnames";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

interface BarChartProps {
  maxAmount: number;
  currentTotalValues: number;
  isError?: boolean;
}

const BarChart = ({
  maxAmount,
  currentTotalValues,
  isError,
}: BarChartProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <p className={classNames(styles.subtitle4, styles.semi_bold)}>
          {t("lbl_total_settlement_amount")}
        </p>
        <p className={styles.amount}>{`${maxAmount.toLocaleString()} ${t(
          "lbl_saudi_currency"
        )}`}</p>
      </div>

      <div className={styles.barWrapper}>
        <div className={styles.progressBar}>
          <div
            className={styles.progressFill}
            style={{
              width: `${(currentTotalValues / maxAmount) * 100}%`,
              backgroundColor: isError ? "#E32A34" : undefined,
            }}
          />
        </div>
      </div>

      <div className={styles.amounts}>
        <div className={styles.amount}>
          <span
            className={styles.dotDark}
            style={{ backgroundColor: isError ? "#E32A34" : "#3ECC85" }}
          />
          <div>
            <span>{t("lbl_settled_amount")}</span>
            <p>
              {currentTotalValues.toLocaleString() +
                " " +
                t("lbl_saudi_currency")}
            </p>
          </div>
        </div>
        <div className={styles.amount}>
          <span
            className={styles.dotLight}
            style={{ backgroundColor: "#EEF0F5" }}
          />
          <div>
            <span>{t("remaining")}</span>
            <p>
              {(maxAmount - currentTotalValues).toLocaleString() +
                " " +
                t("lbl_saudi_currency")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BarChart;
